import algoliaSearch from 'algoliasearch';
import AlgoliaResponse from './AlgoliaResponse';
import {
  ALGOLIA_SEARCH_RESULTS,
  triggerEvent,
} from '@fec/assets/js/utils/event';

import { getFilterValueByKey } from '../searchHelpers';

const ALGOLIA_APP_ID = 'M3VYWCVX2F';
const ALGOLIA_API_KEY = 'b3fcd810980b9997552764f4d18c1946';

// map filter names to facet names for algolia
const FILTER_MAPPINGS = {
  portal: (el) => `(portal.name:'${el.option}')`,
  rubric: (el) => `(rubrics.name:'${el.option}')`,
  subject: (el) => `(tags.fach.value:'${el.option}')`,
  level: (el) => `(tags.stufe.value:'${el.option}')`,
  date: (el) => `(publishedDate > ${getFilterValueByKey(el.option).algolia})`,
};

/*
 * Algolia client prepares & sends a search request directly to Algolia.
 */
export default class AlgoliaClient {
  constructor(indexName, trans, isWebview, config = null) {
    this.trans = trans;
    this.index = algoliaSearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY).initIndex(
      indexName,
    );
    this.isWebview = isWebview;
    this.config = config;
  }

  getArticleSearchOptions(page, hitsPerPage, filters = []) {
    let options = {
      page: page,
      hitsPerPage: hitsPerPage,
      restrictHighlightAndSnippetArrays: true,
      snippetEllipsisText: '…',
      attributesToSnippet: ['lead:15', 'paragraphs:15'],
    };

    if (filters) {
      let algoliaFilters = filters.reduce(function (result, filter) {
        let mapper = FILTER_MAPPINGS[filter.name];
        if (mapper) {
          result.push(mapper(filter));
        }
        return result;
      }, []);

      options.filters = algoliaFilters.join(' AND ');
    }

    return options;
  }
  // search
  getArticles(query, options) {
    return this.index.search(query, options).then((result) => {
      let algoliaResponse = new AlgoliaResponse(
        result,
        this.trans,
        this.isWebview,
      );
      // notify interested subscribers about search results
      triggerEvent(ALGOLIA_SEARCH_RESULTS, algoliaResponse);
      return algoliaResponse;
    });
  }

  getDomains(query) {
    const options = {
      page: 0,
      hitsPerPage: this.config.limit,
    };
    return this.index.search(query, options).then((result) => {
      return result;
    });
  }
}
